export enum LockVendorId {
  SALTO_SPACE = 1,
  ONITY = 2,
  ASSA_ABLOY = 3,
  ACS_LINE_CARD = 4,
  TTLOCK_OFFLINE = 6,
  ACS_LINE_PIN = 8,
  TTLOCK_ONLINE = 9,
  MANUAL_PIN = 10,
  DORMAKABA = 11,
  KEYGURU = 12,
  SMARTKEY = 13,
  TUYA = 14,
  RANDOM_PIN = 15,
  STAR_SMART = 16,
  SALTO_KS = 17,
  NUKI = 19,
}
